import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import 'core-js/stable';
import 'isomorphic-fetch';
import 'abortcontroller-polyfill/dist/polyfill-patch-fetch';
import '@piggybank/core/lib/styles.css';
import '@piggybank/form/lib/styles.css';
import App from 'srcAlias/global/App';
import createStore from 'srcAlias/global/state';
import { getQueryStringValueByKey } from './utils/url';
import 'srcAlias/favicon.ico';

if (window.__RESOURCE_BASE_URL__) {
  __webpack_public_path__ = window.__RESOURCE_BASE_URL__; // eslint-disable-line no-undef
}

const initInitialState = async () => {
  const windowInitialState = window.__INITIAL_STATE__
    ? JSON.parse(window.__INITIAL_STATE__.replace(/\\'/, "'"))
    : {};

  if (__DEV__) {
    let initiaStatePath = getQueryStringValueByKey('initialState');

    if (initiaStatePath) {
      try {
        const initialState = await import(
          `./stubs/initialState/${__MARKET__}/${initiaStatePath}`
        );

        if (initialState && initialState.default) {
          return {
            ...initialState.default,
            ...windowInitialState,
          };
        }
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log(err);
      }
    }
  }

  return windowInitialState;
};

export async function initialize({ rootSelector = '.root' } = {}) {
  if (__DEBUG__) {
    window.TMS = {
      trackView(e) {
        // eslint-disable-next-line no-console
        console.log('TMS.trackView', e);
      },
      trackEvent(e) {
        // eslint-disable-next-line no-console
        console.log('TMS.trackEvent', e);
      },
    };
  }

  const productCodes = window.__PRODUCT_CODES__ || {};
  const initialState = await initInitialState();
  window.__IDENTITY_VERIFIED__ = initialState.identityVerified;

  const store = createStore({
    productCodes,
    ...initialState,
  });

  const rootElement = document.querySelector(rootSelector);

  if (rootElement) {
    render(
      <Provider store={store}>
        <App />
      </Provider>,
      rootElement
    );
  } else {
    throw new Error(
      `Could not attach to element '${rootSelector}'. It doesn't exist in the DOM.`
    );
  }
}

if (process.browser) {
  initialize();
}
